<template>
    <div class="compare-keyfigures">
        <div class="placeholder">
            <div class="placeholder__heading">
                <d-tooltip placement="left" identifier="economy.compare.keyFigures" />
                Nøgletal
            </div>
            <div class="placeholder">
                
                <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    :search-options="searchOptions"
                    :pagination-options="paginationOptions"
                    :sort-options="sortOptions"
                    :styleClass="styleClass"
                    v-if="!loading"
                >
                    <div slot="emptystate">
                        Ingen data ...
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                            <span v-if="props.row.coverage_percent !== 0">
                                {{ props.row.coverage_percent | rounded }} 
                                <div
                                    v-if="props.row.coverage_percent !== null"
                                    class="coverage-indicator"
                                    :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                                />
                            </span>
                            <span v-else>
                                -
                            </span>
                        </div>
                        <div v-else-if="props.column.field == 'total_revenue'">
                            <span v-if="props.row.total_revenue !== 0">
                                {{ props.row.total_revenue | currency}}
                            </span>
                            <span v-else>
                                -
                            </span>
                        </div>
                        <div v-else-if="props.column.field == 'coverage'">
                            <span v-if="props.row.coverage !== 0">
                                {{ props.row.coverage | currency}}
                            </span>
                            <span v-else>
                                -
                            </span>
                        </div>
                        <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                            <span v-if="props.row.coverage_per_hour !== 0">
                                {{ props.row.coverage_per_hour | currency }} 
                                <div
                                    v-if="props.row.coverage_per_hour !== null"
                                    class="coverage-indicator"
                                    :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                                />
                            </span>
                            <span v-else>
                                -
                            </span>
                        </div>
                        <div v-else-if="props.column.field == 'hours_with_customers'" class="coverage-cell" style="text-align:left;">
                            <span v-if="props.row.hours_with_customers !== 0">
                                {{ props.row.hours_with_customers| rounded }} %
                                <div
                                    v-if="props.row.hours_with_customers"
                                    class="coverage-indicator"
                                    :class="{'bad': props.row.hours_with_customers < $store.state.config.companyMeta.settings.timelogging.medium.value, 'avg': $options.filters.rounded(props.row.hours_with_customers) >= $store.state.config.companyMeta.settings.timelogging.medium.value, 'good': $options.filters.rounded(props.row.hours_with_customers) >= $store.state.config.companyMeta.settings.timelogging.high.value}"
                                />
                            </span>
                            <span v-else>
                                -
                            </span>
                        </div>
                        <div v-else-if="props.column.field == 'name'">
                            <strong>{{ props.row.name }}</strong>
                        </div>
                        <div v-else>
                            {{ props.formattedRow[props.column.field] }}
                        </div>
                    </template>
                </vue-good-table>

                <box-loading height="350" v-else />

            </div>
        </div>
    </div>
</template>

<script>
import * as economyService from '@/services/economyService'

export default {
    data () {
        return {
            loading: true,
            rows: [],
            columns: [
                { label: 'Afdeling', field: 'name', type: 'string' },
                { label: 'Opgaver', field: 'projects_count', type: 'number' },
                { label: 'Omsætning', field: 'total_revenue', type: 'number' },
                { label: 'Dækningsbidrag', field: 'coverage', type: 'number' },
                { label: 'DG', field: 'coverage_percent', type: 'number' },
                { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' },
                { label: 'Tid hos kunder', field: 'hours_with_customers', type: 'number' }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 15,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
            /* params: {
                'filter[status]': 'unbilled,billed,posted',
                'include': 'customer,type'
            } */
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            /* if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            } */
            economyService.compareKeyfigures(params, (response) => {
                this.rows = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            // let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// compareKeyfigures.vue?0583f010